import parse from "parse-duration";

/** Shopper Context / analytics keys (SFCC session.custom names). */
export const PERSONALIZATION_CAMPAIGN_ID = "persoCampaignId";
export const PERSONALIZATION_TREATMENT_ID = "persoTreatmentId";
export const PERSONALIZATION_LOCAL_CONTROL = "persoLocalControl";
export const PERSONALIZATION_SOURCE = "persoSource";
export const PERSONALIZATION_DATA_PUSH = "persoDataPush";
export const PERSONALIZATION_EXEC_OFFER = "execPersonalizedOffer";
export const PERSONALIZATION_TREATMENT_CODE = "perso";

/** Accessory added then removed to force SFCC basket promotion recalculation. */
export const PERSONALIZATION_BASKET_RETOUCH_PRODUCT_ID =
  "window-stickers-pack-of-4";

/** Request header set by proxy when `?perso=` is present. */
export const PERSONALIZATION_OVERRIDE_HEADER = "x-personalization";

/** sessionStorage key: intentional modal dismiss (close icon / CTA). */
export const PERSONALIZATION_MODAL_SEEN_KEY = "personalization-modal-seen";

/** Client cookies written by the path-map tracker. */
export const PERSONALIZATION_FULL_PATH_COOKIE = "persoFullPath";
export const PERSONALIZATION_TIME_SPENT_COOKIE = "persoPageTimes";

export const PERSONALIZATION_ACCESS_TOKEN_KEY = "perso:token:access";
export const PERSONALIZATION_TOKEN_SKEW_SECONDS = parse("1m", "s")!;
export const PERSONALIZATION_DEFAULT_TOKEN_TTL_SECONDS = parse("1h", "s")!;
